export const eventTypeLocale: Record<string, string> = {
  wedding: "eventTypeBoda",
  quinceanera: "eventTypeXVAnos",
  birthday: "eventTypeCumpleanos",
  baptism: "eventTypeBautizo",
  farewell: "eventTypeDespedida",
};
